export const FORM_BIG_SIZE_INPUT = 'big';
export const FORM_SMALL_SIZE_CHECKBOX = 'small';
export const FORM_FULL_WIDTH_INPUT = 'full';
export const FORM_TYPE_TEXT_INPUT = 'text';
export const FORM_TYPE_EMAIL_INPUT = 'email';
